__turbopack_context__.v({
  "actions": "sxuMuG_actions",
  "notFoundBody": "sxuMuG_notFoundBody",
  "notFoundPage": "sxuMuG_notFoundPage",
  "restoredPage": "sxuMuG_restoredPage",
  "secondaryAction": "sxuMuG_secondaryAction",
});
